import { createStore, combineReducers } from "redux"

import accountReducer from "./account/reducers"
import accountPackageReducer from "./accountPackage/reducers"
import accountPermissionsReducer from "./accountPermissions/reducers"
import accountSettingsReducer from "./accountSettings/reducers"
import accountUserReducer from "./accountUser/reducers"
import groupReducer from "./group/reducers"
import helpReducer from "./help/reducers"
import mailReducer from "./mail/reducers"
import moduleReducer from "./module/reducers"
import packageReducer from "./package/reducers"
import tagReducer from "./tag/reducers"
import userReducer from "./user/reducers"
import userGroupReducer from "./userGroup/reducers"
import userProfileReducer from "./userProfile/reducers"
import userSettingsReducer from "./userSettings/reducers"
import systemReducer from "./system/reducers"

import billingReducer from "./billing/reducers"

import driveReducer from "./drive/reducers"

import projectSettingsReducer from "./projectSettings/reducers"
import projectReducer from "./project/reducers"
import projectGroupReducer from "./projectGroup/reducers"
import projectPermissionsReducer from "./projectPermissions/reducers"
import projectUserReducer from "./projectUser/reducers"
import projectUserGroupReducer from "./projectUserGroup/reducers"

import ccApprovalLevelReducer from "./ccApprovalLevel/reducers"
import ccLibraryHeadingReducer from "./ccLibraryHeading/reducers"
import ccLibraryItemReducer from "./ccLibraryItem/reducers"
import ccLibrarySetReducer from "./ccLibrarySet/reducers"
import ccLibrarySetModuleReducer from "./ccLibrarySetModule/reducers"
import ccRequirementReducer from "./ccRequirement/reducers"
import ccRequirementPriorityReducer from "./ccRequirementPriority/reducers"
import ccRequirementReviewMethodReducer from "./ccRequirementReviewMethod/reducers"
import ccRequirementSmartComplianceReducer from "./ccRequirementSmartCompliance/reducers"
import ccRequirementStatusReducer from "./ccRequirementStatus/reducers"
import ccRequirementTypeReducer from "./ccRequirementType/reducers"
import ccResponseReducer from "./ccResponse/reducers"
import ccComplianceReducer from "./ccCompliance/reducers"
import ccReviewDocumentReducer from "./ccReviewDocument/reducers"
import ccReviewComplianceReducer from "./ccReviewCompliance/reducers"
import ccReviewReviewReducer from "./ccReviewReview/reducers"
import ccReviewReviewTypeReducer from "./ccReviewReviewType/reducers"

import lifecycleReducer from "./lifecycle/reducers"
import lifecyclePermissionsReducer from "./lifecyclePermissions/reducers"

import qidCompanyReducer from "./qidCompany/reducers"
import qidCompanyDocumentReducer from "./qidCompanyDocument/reducers"
import qidProductReducer from "./qidProduct/reducers"
import qidProductDocumentReducer from "./qidProductDocument/reducers"
import qidModelReducer from "./qidModel/reducers"
import qidDatapointReducer from "./qidDatapoint/reducers"
import qidResultReducer from "./qidResult/reducers"

import silAssumptionReducer from "./silAssumption/reducers"
import silDeviceReducer from "./silDevice/reducers"
import silModelDevicesReducer from "./silModelDevices/reducers"
import silSafetyFunctionReducer from "./silSafetyFunction/reducers"
import silResultSafetyFunctionReducer from "./silResult/reducers"
import silUpdateReducer from "./silUpdate/reducers"

import taskReducer from "./task/reducers"
import taskCommentReducer from "./taskComment/reducers"
import taskObserverReducer from "./taskObserver/reducers"
import taskParticipantReducer from "./taskParticipant/reducers"

import okrKeyResultReducer from "./okrKeyResult/reducers"
import okrKeyResultCommentReducer from "./okrKeyResultComment/reducers"
import okrKeyResultUpdateReducer from "./okrKeyResultUpdate/reducers"
import okrMetricReducer from "./okrMetric/reducers"
import okrObjectiveReducer from "./okrObjective/reducers"
import okrObjectiveCommentReducer from "./okrObjectiveComment/reducers"
import okrSessionReducer from "./okrSession/reducers"

import rrsCategoryReducer from "./rrsCategory/reducers"
import rrsTemplateReducer from "./rrsTemplate/reducers"

import studyReducer from "./study/reducers"
import studySessionReducer from "./studySession/reducers"
import studyTeamMemberReducer from "./studyTeamMember/reducers"

import markovDatasetReducer from "./markovDataset/reducers"
import markovGroupReducer from "./markovGroup/reducers"
import markovGroupStateReducer from "./markovGroupState/reducers"
import markovModelReducer from "./markovModel/reducers"
import markovRedistributionReducer from "./markovRedistribution/reducers"
import markovRedistributionStateReducer from "./markovRedistributionState/reducers"
import markovStartvectorReducer from "./markovStartvector/reducers"
import markovStartvectorStateReducer from "./markovStartvectorState/reducers"
import markovStateReducer from "./markovState/reducers"
import markovTransitionReducer from "./markovTransition/reducers"
import markovVariableReducer from "./markovVariable/reducers"

const rootReducer = combineReducers({
    account: accountReducer,
    accountPackage: accountPackageReducer,
    accountPermissions: accountPermissionsReducer,
    accountSettings: accountSettingsReducer,
    accountUser: accountUserReducer,
    group: groupReducer,
    help: helpReducer,
    mail: mailReducer,
    module: moduleReducer,
    package: packageReducer,
    tag: tagReducer,
    system: systemReducer,
    user: userReducer,
    userGroup: userGroupReducer,
    userProfile: userProfileReducer,
    userSettings: userSettingsReducer,

    billing: billingReducer,

    drive: driveReducer,

    projectSettings: projectSettingsReducer,
    project: projectReducer,
    projectGroup: projectGroupReducer,
    projectPermissions: projectPermissionsReducer,
    projectUser: projectUserReducer,
    projectUserGroup: projectUserGroupReducer,

    ccApprovalLevel: ccApprovalLevelReducer,
    ccCompliance: ccComplianceReducer,
    ccLibraryHeading: ccLibraryHeadingReducer,
    ccLibraryItem: ccLibraryItemReducer,
    ccLibrarySet: ccLibrarySetReducer,
    ccLibrarySetModule: ccLibrarySetModuleReducer,
    ccRequirement: ccRequirementReducer,
    ccRequirementPriority: ccRequirementPriorityReducer,
    ccRequirementReviewMethod: ccRequirementReviewMethodReducer,
    ccRequirementSmartCompliance: ccRequirementSmartComplianceReducer,
    ccRequirementStatus: ccRequirementStatusReducer,
    ccRequirementType: ccRequirementTypeReducer,
    ccResponse: ccResponseReducer,
    ccReviewDocument: ccReviewDocumentReducer,
    ccReviewCompliance: ccReviewComplianceReducer,
    ccReviewReview: ccReviewReviewReducer,
    ccReviewReviewType: ccReviewReviewTypeReducer,

    lifecycle: lifecycleReducer,
    lifecyclePermissions: lifecyclePermissionsReducer,

    qidCompany: qidCompanyReducer,
    qidCompanyDocument: qidCompanyDocumentReducer,
    qidProduct: qidProductReducer,
    qidProductDocument: qidProductDocumentReducer,
    qidModel: qidModelReducer,
    qidDatapoint: qidDatapointReducer,
    qidResult: qidResultReducer,

    silAssumption: silAssumptionReducer,
    silDevice: silDeviceReducer,
    silModelDevices: silModelDevicesReducer,
    silSafetyFunction: silSafetyFunctionReducer,
    silResultSafetyFunction: silResultSafetyFunctionReducer,
    silUpdate: silUpdateReducer,

    task: taskReducer,
    taskComment: taskCommentReducer,
    taskObserver: taskObserverReducer,
    taskParticipant: taskParticipantReducer,

    okrKeyResult: okrKeyResultReducer,
    okrKeyResultComment: okrKeyResultCommentReducer,
    okrKeyResultUpdate: okrKeyResultUpdateReducer,
    okrMetric: okrMetricReducer,
    okrObjective: okrObjectiveReducer,
    okrObjectiveComment: okrObjectiveCommentReducer,
    okrSession: okrSessionReducer,

    rrsCategory: rrsCategoryReducer,
    rrsTemplate: rrsTemplateReducer,

    study: studyReducer,
    studySession: studySessionReducer,
    studyTeamMember: studyTeamMemberReducer,

    markovDataset: markovDatasetReducer,
    markovGroup: markovGroupReducer,
    markovGroupState: markovGroupStateReducer,
    markovModel: markovModelReducer,
    markovRedistribution: markovRedistributionReducer,
    markovRedistributionState: markovRedistributionStateReducer,
    markovStartvector: markovStartvectorReducer,
    markovStartvectorState: markovStartvectorStateReducer,
    markovState: markovStateReducer,
    markovTransition: markovTransitionReducer,
    markovVariable: markovVariableReducer,
})

export const store = createStore(rootReducer)
export type StoreType = ReturnType<typeof rootReducer>

export * from "./utils/permissions/const"

export * from "./account/types"
export * from "./account/actions"
export * from "./account/reducers"
export * from "./account/utils"

export * from "./accountPackage/types"
export * from "./accountPackage/actions"
export * from "./accountPackage/reducers"
export * from "./accountPackage/utils"

export * from "./accountPermissions/types"
export * from "./accountPermissions/actions"
export * from "./accountPermissions/reducers"
export * from "./accountPermissions/utils"

export * from "./accountSettings/types"
export * from "./accountSettings/actions"
export * from "./accountSettings/reducers"
export * from "./accountSettings/utils"

export * from "./accountUser/types"
export * from "./accountUser/actions"
export * from "./accountUser/reducers"
export * from "./accountUser/utils"

export * from "./billing/types"
export * from "./billing/actions"
export * from "./billing/reducers"
export * from "./billing/utils"

export * from "./ccApprovalLevel/types"
export * from "./ccApprovalLevel/actions"
export * from "./ccApprovalLevel/reducers"
export * from "./ccApprovalLevel/utils"

export * from "./ccCompliance/types"
export * from "./ccCompliance/actions"
export * from "./ccCompliance/reducers"
export * from "./ccCompliance/utils"

export * from "./ccLibraryHeading/types"
export * from "./ccLibraryHeading/actions"
export * from "./ccLibraryHeading/reducers"
export * from "./ccLibraryHeading/utils"

export * from "./ccLibraryItem/types"
export * from "./ccLibraryItem/actions"
export * from "./ccLibraryItem/reducers"
export * from "./ccLibraryItem/utils"

export * from "./ccLibrarySet/types"
export * from "./ccLibrarySet/actions"
export * from "./ccLibrarySet/reducers"
export * from "./ccLibrarySet/utils"

export * from "./ccLibrarySetModule/types"
export * from "./ccLibrarySetModule/actions"
export * from "./ccLibrarySetModule/reducers"
export * from "./ccLibrarySetModule/utils"

export * from "./ccRequirement/types"
export * from "./ccRequirement/actions"
export * from "./ccRequirement/reducers"
export * from "./ccRequirement/utils/history"
export * from "./ccRequirement/utils/lifecyclePhase"
export * from "./ccRequirement/utils/parentChild"
export * from "./ccRequirement/utils/requirement"
export * from "./ccRequirement/utils/revision"
export * from "./ccRequirement/utils/state"
export * from "./ccRequirement/utils/tempAnswer"
export * from "./ccRequirement/utils/version"

export * from "./ccRequirementPriority/types"
export * from "./ccRequirementPriority/actions"
export * from "./ccRequirementPriority/reducers"
export * from "./ccRequirementPriority/utils"

export * from "./ccRequirementReviewMethod/types"
export * from "./ccRequirementReviewMethod/actions"
export * from "./ccRequirementReviewMethod/reducers"
export * from "./ccRequirementReviewMethod/utils"

export * from "./ccRequirementSmartCompliance/types"
export * from "./ccRequirementSmartCompliance/actions"
export * from "./ccRequirementSmartCompliance/reducers"
export * from "./ccRequirementSmartCompliance/utils"

export * from "./ccRequirementStatus/types"
export * from "./ccRequirementStatus/actions"
export * from "./ccRequirementStatus/reducers"
export * from "./ccRequirementStatus/utils"

export * from "./ccRequirementType/types"
export * from "./ccRequirementType/actions"
export * from "./ccRequirementType/reducers"
export * from "./ccRequirementType/utils"

export * from "./ccResponse/types"
export * from "./ccResponse/actions"
export * from "./ccResponse/reducers"
export * from "./ccResponse/utils"

export * from "./ccReviewDocument/types"
export * from "./ccReviewDocument/actions"
export * from "./ccReviewDocument/reducers"
export * from "./ccReviewDocument/utils"

export * from "./ccReviewCompliance/types"
export * from "./ccReviewCompliance/actions"
export * from "./ccReviewCompliance/reducers"
export * from "./ccReviewCompliance/utils"

export * from "./ccReviewReview/types"
export * from "./ccReviewReview/actions"
export * from "./ccReviewReview/reducers"
export * from "./ccReviewReview/utils"

export * from "./ccReviewReviewType/types"
export * from "./ccReviewReviewType/actions"
export * from "./ccReviewReviewType/reducers"
export * from "./ccReviewReviewType/utils"

export * from "./drive/types"
export * from "./drive/actions"
export * from "./drive/reducers"
export * from "./drive/utils"

export * from "./group/types"
export * from "./group/actions"
export * from "./group/reducers"
export * from "./group/utils"

export * from "./help/types"
export * from "./help/actions"
export * from "./help/reducers"
export * from "./help/utils"

export * from "./lifecycle/types"
export * from "./lifecycle/actions"
export * from "./lifecycle/reducers"
export * from "./lifecycle/utils/lifecycle"
export * from "./lifecycle/utils/phase"
export * from "./lifecycle/utils/connection"
export * from "./lifecycle/utils/documents"

export * from "./lifecyclePermissions/types"
export * from "./lifecyclePermissions/actions"
export * from "./lifecyclePermissions/reducers"
export * from "./lifecyclePermissions/utils"

export * from "./mail/const"
export * from "./mail/types"
export * from "./mail/actions"
export * from "./mail/reducers"
export * from "./mail/utils"

export * from "./markovDataset/types"
export * from "./markovDataset/actions"
export * from "./markovDataset/reducers"
export * from "./markovDataset/utils"

export * from "./markovGroup/types"
export * from "./markovGroup/actions"
export * from "./markovGroup/reducers"
export * from "./markovGroup/utils"

export * from "./markovGroupState/types"
export * from "./markovGroupState/actions"
export * from "./markovGroupState/reducers"
export * from "./markovGroupState/utils"

export * from "./markovModel/types"
export * from "./markovModel/actions"
export * from "./markovModel/reducers"
export * from "./markovModel/utils"

export * from "./markovRedistribution/types"
export * from "./markovRedistribution/actions"
export * from "./markovRedistribution/reducers"
export * from "./markovRedistribution/utils"

export * from "./markovRedistributionState/types"
export * from "./markovRedistributionState/actions"
export * from "./markovRedistributionState/reducers"
export * from "./markovRedistributionState/utils"

export * from "./markovStartvector/types"
export * from "./markovStartvector/actions"
export * from "./markovStartvector/reducers"
export * from "./markovStartvector/utils"

export * from "./markovStartvectorState/types"
export * from "./markovStartvectorState/actions"
export * from "./markovStartvectorState/reducers"
export * from "./markovStartvectorState/utils"

export * from "./markovState/types"
export * from "./markovState/actions"
export * from "./markovState/reducers"
export * from "./markovState/utils"

export * from "./markovTransition/types"
export * from "./markovTransition/actions"
export * from "./markovTransition/reducers"
export * from "./markovTransition/utils"

export * from "./markovVariable/types"
export * from "./markovVariable/actions"
export * from "./markovVariable/reducers"
export * from "./markovVariable/utils/variables"
export * from "./markovVariable/utils/datasetExpressions"
export * from "./markovVariable/utils/expressionHelpers"

export * from "./module/types"
export * from "./module/actions"
export * from "./module/reducers"
export * from "./module/utils"

export * from "./okrKeyResult/types"
export * from "./okrKeyResult/actions"
export * from "./okrKeyResult/reducers"
export * from "./okrKeyResult/utils"

export * from "./okrKeyResultComment/types"
export * from "./okrKeyResultComment/actions"
export * from "./okrKeyResultComment/reducers"
export * from "./okrKeyResultComment/utils"

export * from "./okrKeyResultUpdate/types"
export * from "./okrKeyResultUpdate/actions"
export * from "./okrKeyResultUpdate/reducers"
export * from "./okrKeyResultUpdate/utils"

export * from "./okrMetric/types"
export * from "./okrMetric/actions"
export * from "./okrMetric/reducers"
export * from "./okrMetric/utils"

export * from "./okrObjective/types"
export * from "./okrObjective/actions"
export * from "./okrObjective/reducers"
export * from "./okrObjective/utils"
export * from "./okrObjective/prepareNested"

export * from "./okrObjectiveComment/types"
export * from "./okrObjectiveComment/actions"
export * from "./okrObjectiveComment/reducers"
export * from "./okrObjectiveComment/utils"

export * from "./okrSession/types"
export * from "./okrSession/actions"
export * from "./okrSession/reducers"
export * from "./okrSession/utils"
export * from "./okrSession/prepareNested"

export * from "./package/types"
export * from "./package/actions"
export * from "./package/reducers"
export * from "./package/utils/package"
export * from "./package/utils/packageAllowed"

export * from "./project/types"
export * from "./project/actions"
export * from "./project/reducers"
export * from "./project/utils"

export * from "./projectGroup/types"
export * from "./projectGroup/actions"
export * from "./projectGroup/reducers"
export * from "./projectGroup/utils"

export * from "./projectPermissions/types"
export * from "./projectPermissions/actions"
export * from "./projectPermissions/reducers"
export * from "./projectPermissions/utils"

export * from "./projectSettings/types"
export * from "./projectSettings/actions"
export * from "./projectSettings/reducers"
export * from "./projectSettings/utils"

export * from "./projectUser/types"
export * from "./projectUser/actions"
export * from "./projectUser/reducers"
export * from "./projectUser/utils"

export * from "./projectUserGroup/types"
export * from "./projectUserGroup/actions"
export * from "./projectUserGroup/reducers"
export * from "./projectUserGroup/utils"

export * from "./qidCompany/types"
export * from "./qidCompany/actions"
export * from "./qidCompany/reducers"
export * from "./qidCompany/utils"

export * from "./qidCompanyDocument/types"
export * from "./qidCompanyDocument/actions"
export * from "./qidCompanyDocument/reducers"
export * from "./qidCompanyDocument/utils"

export * from "./qidDatapoint/types"
export * from "./qidDatapoint/actions"
export * from "./qidDatapoint/reducers"
export * from "./qidDatapoint/utils"

export * from "./qidModel/types"
export * from "./qidModel/actions"
export * from "./qidModel/reducers"
export * from "./qidModel/utils/failureModes"
export * from "./qidModel/utils/models"
export * from "./qidModel/utils/options"
export * from "./qidModel/utils/safetyFunctions"

export * from "./qidProduct/types"
export * from "./qidProduct/actions"
export * from "./qidProduct/reducers"
export * from "./qidProduct/utils"

export * from "./qidProductDocument/types"
export * from "./qidProductDocument/actions"
export * from "./qidProductDocument/reducers"
export * from "./qidProductDocument/utils"

export * from "./qidResult/types"
export * from "./qidResult/actions"
export * from "./qidResult/reducers"
export * from "./qidResult/utils"

export * from "./rrsCategory/types"
export * from "./rrsCategory/actions"
export * from "./rrsCategory/reducers"
export * from "./rrsCategory/utils"
export * from "./rrsCategory/prepareNested"

export * from "./rrsTemplate/types"
export * from "./rrsTemplate/actions"
export * from "./rrsTemplate/reducers"
export * from "./rrsTemplate/utils/template"
export * from "./rrsTemplate/utils/label"
export * from "./rrsTemplate/utils/labelCategory"
export * from "./rrsTemplate/utils/level"
export * from "./rrsTemplate/utils/riskRank"

export * from "./silAssumption/types"
export * from "./silAssumption/actions"
export * from "./silAssumption/reducers"

export * from "./silDevice/types"
export * from "./silDevice/actions"
export * from "./silDevice/reducers"
export * from "./silDevice/utils/devices"
export * from "./silDevice/utils/nestedDevices"

export * from "./silModelDevices/types"
export * from "./silModelDevices/actions"
export * from "./silModelDevices/reducers"

export * from "./silResult/types"
export * from "./silResult/actions"
export * from "./silResult/reducers"
export * from "./silResult/utils/projectDevices"
export * from "./silResult/utils/safetyFunctions"
export * from "./silResult/utils/subsystems"

export * from "./silSafetyFunction/types"
export * from "./silSafetyFunction/actions"
export * from "./silSafetyFunction/reducers"
export * from "./silSafetyFunction/utils/safetyFunctions"
export * from "./silSafetyFunction/utils/subsystems"

export * from "./silUpdate/types"
export * from "./silUpdate/actions"
export * from "./silUpdate/reducers"

export * from "./study/types"
export * from "./study/actions"
export * from "./study/reducers"
export * from "./study/utils"

export * from "./studySession/types"
export * from "./studySession/actions"
export * from "./studySession/reducers"
export * from "./studySession/utils"

export * from "./studyTeamMember/types"
export * from "./studyTeamMember/actions"
export * from "./studyTeamMember/reducers"
export * from "./studyTeamMember/utils"

export * from "./system/types"
export * from "./system/actions"
export * from "./system/reducers"
export * from "./system/utils"

export * from "./tag/types"
export * from "./tag/actions"
export * from "./tag/reducers"
export * from "./tag/utils"

export * from "./task/types"
export * from "./task/actions"
export * from "./task/reducers"
export * from "./task/utils"
export * from "./task/prepareNested"
export * from "./task/access"

export * from "./taskComment/types"
export * from "./taskComment/actions"
export * from "./taskComment/reducers"
export * from "./taskComment/utils"

export * from "./taskObserver/types"
export * from "./taskObserver/actions"
export * from "./taskObserver/reducers"
export * from "./taskObserver/utils"

export * from "./taskParticipant/types"
export * from "./taskParticipant/actions"
export * from "./taskParticipant/reducers"
export * from "./taskParticipant/utils"

export * from "./user/types"
export * from "./user/actions"
export * from "./user/reducers"
export * from "./user/utils"

export * from "./userGroup/types"
export * from "./userGroup/actions"
export * from "./userGroup/reducers"
export * from "./userGroup/utils"

export * from "./userProfile/types"
export * from "./userProfile/actions"
export * from "./userProfile/reducers"

export * from "./userSettings/types"
export * from "./userSettings/actions"
export * from "./userSettings/reducers"
export * from "./userSettings/utils"
